import ProductDetail from "../../../../pages-v1/ProductDetail";
export const Page = ProductDetail;
